export * from './getting-started/getting-started.page'
export * from './forms/forms.page'
export * from './home/home.page'
export * from './props/props.page'
export * from './providers/providers.page'
